// extracted by css-extract-rspack-plugin
export default {"CodeContainer":"fGu5t","isHighlighted":"B3kSC","CodeText":"ZHZaN","CodeRoot":"u1D_n","CodeCopyButton":"wJ9Bb"};